// removed by extract-text-webpack-plugin
module.exports = {"invalid":"text-input__invalid__33hZO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/text-input.scss
// module id = 1206
// module chunks = 1